setTimeout(() => {
    const flyout = {
        container: {},
        state: {
            open: false
        },
        open, close: () => { console.log('Not ready'); }
    };

    document.addEventListener('keydown', (event) => {
        let inputTags = [ 'INPUT', 'TEXTAREA' ];

        if ( inputTags.includes(event.target.tagName)) return;

        switch (event.code) {
            case 'KeyF':
                flyout.state.open ? flyout.close() : flyout.open();
                break;
            case 'Escape':
                flyout.close();
                break;
        }
    });

    document.addEventListener('click', (event) => {
        if  ( flyout.state.open && !event.target.closest('.sidebar, .flyout-button, .toggle-flyout') ) {
            flyout.close();
        }
        if  ( event.target.closest('.toggle-flyout') ) {
            flyout.state.open ? flyout.close() : flyout.open();
        }
    });

    document.addEventListener('DOMContentLoaded', function() {
      var seeMoreButton = document.getElementById('see-more-btn');
      var items = document.querySelectorAll('.custom-subcat-list li');
      if (items.length <= 6) {
        if (seeMoreButton) {
          seeMoreButton.style.display = 'none';
        }
      } else {
        if (seeMoreButton) {
          seeMoreButton.addEventListener('click', function() {
            var isExpanded = this.getAttribute('data-expanded') === 'true';
            items.forEach(function(item, index) {
              if (index >= 6) {
                item.style.display = isExpanded ? 'none' : 'block';
                if (isExpanded) {
                  item.classList.remove('expanded');
                } else {
                  item.classList.add('expanded');
                }
              }
            });
            // Toggle button text and expanded state
            if (isExpanded) {
              this.textContent = 'Se flere';
              this.setAttribute('data-expanded', 'false');
            } else {
              this.textContent = 'Se mindre';
              this.setAttribute('data-expanded', 'true');
            }
          });
        }
      }
    });

    function toggleBodyClass() {
        let body = document.getElementsByTagName('body').item(0);

        flyout.state.open ? body.classList.add('flyout-open') : body.classList.remove('flyout-open');
    }

    flyout.open = () => {
        flyout.state.open = true;
        flyout.container.classList.add("show");
        toggleBodyClass();
    };

    flyout.close = () => {
        flyout.state.open = false;
        flyout.container.classList.remove("show");
        toggleBodyClass();
    };

    flyout.container = document.getElementsByClassName('sidebar').item(0);

    let closeButton = document.createElement('a');
    closeButton.classList.add('close', 'fa', 'fa-close');
    closeButton.title = 'Steng';
    closeButton.href = '#';
    closeButton.addEventListener('click', flyout.close );

    flyout.container.prepend(closeButton);

    let menuLink = document.createElement('a');
    menuLink.classList.add('flyout-button');
    menuLink.textContent = 'Vis filter';
    menuLink.href = '#';
    menuLink.addEventListener('click', (event) => {
        event.preventDefault();
        flyout.state.open ? flyout.close() : flyout.open();
    });

    const footer = document.getElementsByTagName('footer').item(0);

    const footerButtons = document.createElement('div');
    footerButtons.classList.add( 'footer-buttons' );
    const firstFooterButton = document.createElement('div');
    firstFooterButton.classList.add( 'first-footer-button' );

    firstFooterButton.appendChild(menuLink);
    footerButtons.append( firstFooterButton );
    footer.append( footerButtons );

}, 0);